export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11434.8ece6732.jpg";